import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import KanbanBoard from "@/components/KanbanBoard";
import { LogIn, FileText } from "lucide-react";

const COLUMNS = [
  { id: "entrou", label: "Entrou", accent: "bg-slate-500" },
  { id: "agendado", label: "Agendado", accent: "bg-sky-500" },
  { id: "recebido", label: "Recebido", accent: "bg-amber-500" },
  { id: "em_inspecao", label: "Em Inspeção", accent: "bg-yellow-500" },
  { id: "estimate", label: "Estimate", accent: "bg-neutral-500" },
  { id: "kit_enviado", label: "Kit Enviado", accent: "bg-indigo-500" },
  { id: "aguardando_aprovacao", label: "Aguard. Aprovação", accent: "bg-orange-500" },
  { id: "aprovado", label: "Aprovado", accent: "bg-cyan-500" },
  { id: "em_reparo", label: "Em Reparo", accent: "bg-primary" },
  { id: "pronto", label: "Pronto", accent: "bg-emerald-500" },
  { id: "entregue", label: "Entregue", accent: "bg-neutral-500" },
  { id: "aguardando_pagamento", label: "Aguard. Pagamento", accent: "bg-red-500" },
];

export default function GarantiasKanban() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/jobs", { params: { job_type: "warranty" } });
    setJobs(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const onStatusChange = async (jobId, newStatus) => {
    await api.patch(`/jobs/${jobId}/status`, { status: newStatus });
  };

  const renderExtra = (j) => {
    const claim = j.extra?.claim;
    const empresa = j.extra?.empresa;
    const deductible = j.extra?.deductible;
    if (!claim && !empresa) return null;
    return (
      <div className="mt-1.5 flex flex-wrap items-center gap-1 text-[10px]">
        {empresa && <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-purple-500/10 text-purple-500 truncate"><FileText className="w-2.5 h-2.5" />{empresa}</span>}
        {claim && <span className="font-mono text-muted-foreground">#{claim}</span>}
        {deductible != null && <span className="font-mono text-red-500">Ded ${deductible}</span>}
      </div>
    );
  };

  return (
    <div className="space-y-4 -mt-2" data-testid="garantias-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Garantias Estendidas</div>
          <h1 className="font-display text-3xl font-bold tracking-tight">Kanban Garantias</h1>
          <p className="text-sm text-muted-foreground mt-1">Empresas de warranty, claim, deductible, inspector — pipeline completo até pagamento.</p>
        </div>
        <Button onClick={() => navigate("/check-in?type=warranty")} data-testid="garantias-checkin-btn">
          <LogIn className="w-4 h-4" /> Novo Check-In Garantia
        </Button>
      </div>
      {loading ? <div className="text-sm text-muted-foreground">Carregando…</div> :
        <KanbanBoard columns={COLUMNS} jobs={jobs} onStatusChange={onStatusChange} renderCardExtra={renderExtra} onJobsChanged={load} />}
    </div>
  );
}
